export default __webpack_public_path__ + "static/media/user-solid.05c6e2e8.svg";